export const PUBLIC_PROFILE_STORE_KEY = 'publicFinanceProfile';
export const PUBLIC_PROGRAMS_STORE_KEY = 'publicMatchedFinancePrograms';

export const getFinanceProfileStoreKey = (userWixId) => `userFinanceProfile_${userWixId}`;
export const getMatchedFinanceProgramsStoreKey = (userWixId) => `userMatchedFinancePrograms_${userWixId}`;
